const pendoApiKey = process.env.PENDO_API_KEY;
const pendo = window.pendo;

const hasPendo = pendoApiKey && pendo;

const pendoWrapper = {
  init: () => {
    // no-op
  },
  config: (config) => {
    const {
      href,
      integrationType,
      orgId,
      participantId,
      slug,
      tenantId,
      tenantName,
      userAgent,
      userLevel,
      username,
    } = config;

    if (hasPendo) {
      pendo.initialize({
        visitor: {
          id: participantId,
          integrationType,
          location: href,
          orgId,
          userAgent,
          userLevel,
          username,
        },
        account: {
          id: tenantId,
          name: tenantName,
          slug: slug
        }
      });
    }
  },
};

export default pendoWrapper;



// WEBPACK FOOTER //
// src/tracking/pendo.js